var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.7,22.4c-1.3,0-2.4,1.1-2.4,2.4c0,0,0,0,0,0v7.1H5.7v-7.1c0-1.3-1.1-2.4-2.4-2.4S1,23.4,1,24.8v9.5 c0,1.3,1.1,2.4,2.4,2.4c0,0,0,0,0,0h33.3c1.3,0,2.4-1.1,2.4-2.4c0,0,0,0,0,0v-9.5C39.1,23.4,38,22.4,36.7,22.4 C36.7,22.4,36.7,22.4,36.7,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,26.4c0.9,0.9,2.4,0.9,3.4,0c0,0,0,0,0,0l7.1-7.1c0.9-0.9,0.9-2.4,0-3.4c-0.9-0.9-2.4-0.9-3.4,0L22.4,19 V5.7c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4V19l-3.1-3.1c-0.9-0.9-2.4-0.9-3.4,0c-0.9,0.9-0.9,2.4,0,3.4L18.3,26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfIcon);
export default __webpack_public_path__ + "static/media/download_pdf_icon.d92a59733a98cf7deaea8f8ad5420111.svg";
export { ForwardRef as ReactComponent };